<template>
  <a-card :bordered='false'>
    <SmallSquare class="m-b-20" content="1、手机短信推送服务，可应用在会员营销、客户关怀、云店通知、商品防伪、销售导购等多营销场景中，短信推送为计费服务，推送条数直接在本账号的短信剩余条数中扣除，剩余数量为0时将会推送失败；
2、您可以在消息推送管理设置交易、互动、通知等消息场景是否启用短信推送及规则；
3、短信一切服务由第三方短信通道商提供，短信购买可开具发票；充值短信不受理退费处理，请确认后购买，详细介绍可查看购买须知。" />
    <div class='p-l-30 p-r-30'>
      <div class="square  m-b-40 s_c333 s_flex_bian_c">
        <div>
          <div>短信数量为 <span class='s_font_b s_cd41 fz-34'>{{total}}</span> 条 {{total==0?',':''}}<span class='s_cd41'
              v-if='total==0'>无法发送，购买短信包后可正常使用。</span></div>
          <!-- <div @click="setShow=true">为避免短信不足，影响业务正常进行，您可以进行<span class='s_c376 s_shou'>短信不足提醒设置(免费)</span></div> -->
        </div>
        <a-button type="primary" v-has:smsOrder="()=> {$router.push('/messageCenter/sms/smsCenter/smsOrder')}">充值记录</a-button>
      </div>
      <ul class='setMeal s_flex_ali '>
        <li v-for="(v,k) in packages" :key="k">
          <p class='m-b-7'>{{v.num}}条</p>
          <p class='money s_cd41 s_font_b m-b-12'><span class='fz-13'>￥</span>{{v.amount}}</p>
          <p class='s_c8e fz-12 m-b-25 '>低至{{(v.amount/v.num).toFixed(3)}}元/条</p>
          <a-button type="primary" v-has:smsPlayNow="()=>{orderVisible=true;orderData=v}">
            立即充值
          </a-button>
        </li>
      </ul>
    </div>
  </a-card>
  <a-card class='m-t-15' title='发送情况' :bordered='false'>
    <a-radio-group v-model:value="time" @change="onChange">
      <a-radio-button :value="1">
        昨天
      </a-radio-button>
      <a-radio-button :value="2">
        近7天
      </a-radio-button>
      <a-radio-button :value="3">
        近30天
      </a-radio-button>
    </a-radio-group>
    <a-spin :spinning="loading">
      <a-row class='m-t-50 s_c333 m-b-50' :gutter="16">
        <a-col :span="8">
          <p class='fz-18'>短信发送总数</p>
          <p class='fz-40 s_font_b'>{{SendStatistics.total || 0}}</p>
        </a-col>
        <a-col :span="8">
          <p class='fz-18'>短信成功到达数</p>
          <p class='fz-40 s_font_b'>{{SendStatistics.success || 0}}</p>
        </a-col>
        <a-col :span="8">
          <p class='fz-18'>短信计费数量</p>
          <p class='fz-40 s_font_b'>{{SendStatistics.quantity || 0}}</p>
        </a-col>
      </a-row>
    </a-spin>
  </a-card>
  <a-card class='m-t-15' title='短信应用场景' :bordered='false'>
    <div class='s_flex_center'>
      <a-radio-group v-model:value="value">
        <a-radio-button value="a">
          会员营销
        </a-radio-button>
        <a-radio-button value="b">
          客户关怀
        </a-radio-button>
        <a-radio-button value="c">
          消息通知
        </a-radio-button>
      </a-radio-group>
    </div>
    <p class='m-t-40 m-b-70'>适合品牌商发布推广活动、促销信息等场景。创建短信审核后，即可对自家所有会员或者导入会员手机号进行推送 <br />
      从而提高营销活动的曝光与转化</p>
  </a-card>
  <a-modal :keyboard="false" title="确认订单" centered v-model:visible="orderVisible" @ok="orderHandle" destroyOnClose>
    <a-form :label-col="{span:4}" :wrapper-col="{span:20}">
      <a-form-item label='短信条数' style="margin:0">
        {{orderData.num}}
      </a-form-item>
      <a-form-item label='应付金额' style="margin:0">
        {{orderData.amount}}
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 上传图片 -->
  <a-modal :keyboard="false" title="支付" centered v-model:visible="codeVisible" @ok="codeVisible=false" destroyOnClose>
    <div class='s_text_c'>
      <img :src="codeUrl" alt="" class='s_mauto' style="display:block">
    </div>
  </a-modal>
  <!-- 设置提醒 -->
  <a-modal :keyboard="false" title="设置提醒" centered v-model:visible="setShow" @ok="remindSubmit"
    @cancel="setShow=false;setNumber=null" destroyOnClose>
    <span>在短信剩余数达到设置的数值时，系统将会发送一条短信到负责人的手机</span>
    <div class="m-t-20">
      <span class="p-r-10">短信剩余</span>
      <a-input-number class='width-150' v-model:value="setNumber" placeholder="请输入数量" :precision="0"></a-input-number>
      <span class="p-l-10">条时提醒我</span>
    </div>
  </a-modal>
</template>
<script>
  import {
    getSmsPackage,
    getSmsSurplus,
    getSmsSendStatistics,
    buySmsPackage,
    getSmsOrderDetail,
    getSmsBuyCode

  } from "@/api/message";
  import { inject, onMounted, reactive, ref, toRefs } from "vue";
  import { message } from 'ant-design-vue';
  import { iscode } from '@/utils/app';
  import store from '@/store'
  export default {
    name: "",
    setup() {
      onMounted(() => {
        getSurplus();
        getPackages();
        getSendStatistics();
      });
      const state = reactive({
        orderVisible: false,
        orderData: {},
        info: store.state.user.info,
        setShow: false,
        setNumber: null
      })
      // 获取剩余条数
      const total = ref(0);
      const getSurplus = async () => {
        let result = await getSmsSurplus()
          .then((res) => res.data)
          .catch((error) => error);
        total.value = result.data.num;
        var info = JSON.parse(JSON.stringify(state.info))
        info.overView.remaining_number = total.value
        store.dispatch('user/setUserInfo', info);
      };
      // 获取套餐
      const packages = ref([]);
      const getPackages = async () => {
        let result = await getSmsPackage().then((res) => res.data).catch((error) => error);
        packages.value = result.data;
      };
      // 发送情况
      const time = ref(1);
      const loading = ref(false)
      const SendStatistics = ref({});
      const getSendStatistics = async () => {
        loading.value = true
        let result = await getSmsSendStatistics({ type: time.value })
          .then((res) => res.data)
          .catch((error) => error);
        loading.value = false
        SendStatistics.value = result.data;
      };
      const onChange = (e) => {
        time.value = e.target.value
        getSendStatistics();
      };
      const codeVisible = ref(false)
      const codeUrl = ref('')
      const $router = inject('$router')
      const orderHandle = async () => {
        const hide = message.loading('正在加载中...', 0);
        let result = await buySmsPackage({ package_id: state.orderData.id }).then(res => res.data).catch(error => error)
        if (iscode(result, true)) {
          $router.push({ path: '/messageCenter/sms/playDetail', query: { order_no: result.data.insert } })
        }
        setTimeout(hide);
      }
      //提醒设置
      const remindSubmit = () => {

      }
      return {
        codeVisible,
        codeUrl,
        total, //剩余条数
        packages, //套餐
        SendStatistics,
        time,
        loading,
        onChange,
        orderHandle,
        ...toRefs(state),
        remindSubmit
      };
    },
  };
</script>
<style lang="less" scoped>
  .square {
    letter-spacing: 0.1em;
    /* cursor: pointer; */
  }

  .setMeal {
    width: 100%;
    flex-wrap: wrap;

    li {
      width: 182px;
      margin-right: 45px;
      box-shadow: 0px 0px 22px 0px #dbe7f3;
      height: 218px;
      box-sizing: border-box;
      border-radius: 10px;
      text-align: center;
      padding: 26px 0;
      font-size: 24px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 15px;
    }
  }

  p {
    text-align: center;
  }
</style>